import React from 'react';
import { useParams } from 'react-router-dom';

import { organizationPlansPath } from 'application/types/routes';
import { ApplicationParams } from 'types/route_params';

import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Text } from 'components/Text/Text';

export type UpgradeCalloutProps = {
  buttonLabel?: string;
  children: React.ReactNode;
  className?: string;
};

export function UpgradeCallout({
  buttonLabel = 'Compare plans',
  children,
  className,
}: UpgradeCalloutProps) {
  const { applicationID } = useParams<ApplicationParams>();
  const { data: organization } = useCurrentOrganization();

  if (!organization) {
    return null;
  }

  return (
    <Box
      className={`grid justify-items-start gap-[var(--size-sm)]${className ? ` ${className}` : ''}`}
      size="small"
      variant="primary"
      theme="inverted"
    >
      <Text type="paragraph">{children}</Text>
      <Button
        size="small"
        variant="primary"
        to={organizationPlansPath(applicationID, organization.id)}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
}
